/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DisconnectedUsageResponse } from './disconnectedUsageResponse';


export interface DisconnectedUsageBulkResponse { 
    disconnected_usages?: Array<DisconnectedUsageResponse>;
    total_record_count?: number;
}

